// src/components/ia-paca/IaStackBadges.tsx
//
// Stack IA moderne — preuve technique forte. Aucun cabinet RH français
// classique ne sait écrire cette liste. C'est notre signal "on opère
// vraiment", pas "on a entendu parler de l'IA".

const STACK_GROUPS = [
  {
    label: 'Frameworks & Orchestration',
    items: [
      'LangChain',
      'LlamaIndex',
      'Pydantic AI',
      'Semantic Kernel',
      'Haystack',
      'LangGraph',
      'Crew AI',
      'AutoGen',
    ],
  },
  {
    label: 'LLM Providers',
    items: [
      'OpenAI',
      'Anthropic Claude',
      'Mistral',
      'Cohere',
      'HuggingFace',
      'Together',
      'Groq',
    ],
  },
  {
    label: 'Vector DB & Retrieval',
    items: ['Pinecone', 'Weaviate', 'Qdrant', 'pgvector', 'Chroma', 'Vespa'],
  },
  {
    label: 'MLOps & Observabilité',
    items: [
      'MLflow',
      'Weights & Biases',
      'Langfuse',
      'Vertex AI',
      'SageMaker',
      'Helicone',
    ],
  },
  {
    label: 'Inference & Serving',
    items: ['vLLM', 'Ollama', 'Replicate', 'TGI', 'Modal', 'Banana'],
  },
  {
    label: 'Automatisation IA',
    items: ['n8n', 'Make', 'Zapier', 'MCP', 'OpenAPI tools', 'Temporal'],
  },
];

export default function IaStackBadges() {
  return (
    <div className="space-y-5">
      {STACK_GROUPS.map((g) => (
        <div key={g.label}>
          <div className="mb-2 text-[10px] font-bold uppercase tracking-wider text-violet-700">
            {g.label}
          </div>
          <div className="flex flex-wrap gap-1.5">
            {g.items.map((item) => (
              <span
                key={item}
                className="inline-flex items-center rounded-md border border-slate-200 bg-white px-2.5 py-1 font-mono text-[11px] text-slate-700"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
